import React from 'react';
import PropTypes from 'prop-types';
import propTypes from 'helpers/propTypes';
import {Box} from '@material-ui/core';

const Assessment = ({gutterBottom, className, children, ...rest}) => (
  <Box marginBottom={gutterBottom ? 4 : 0} className={className} {...rest}>
    {children}
  </Box>
);

Assessment.propTypes = {
  className: PropTypes.string,
  gutterBottom: PropTypes.bool,
  page: propTypes.page.isRequired,
};

export default Assessment;
